module.exports = __webpack_public_path__ + "img/rightReceived_en-GB.d32ea815.png";